<script>
    import {network, store} from '../stores.js';
    import TopMenu from '../components/TopMenu.svelte';
    import {Link} from 'svelte-routing';
    import BottomMenu from '../components/BottomMenu.svelte';

    export let id;
    export let vid;

    const user = store('credential', 'getAuth');
    const axis = store('axis', '', false);

    const fetchOrder = async () => {
        let data = await network.getOrder({id, user_kontr: +$user.idkontr ,vid});

        tv = data.order.tv;
        delivery = data.order.tipDost;
        idKontakt = data.order.idKontakt;
        nameKontakt = data.order.nameKontakt;
        telefonKontakt = data.order.telefonKontakt;
        adresKontakt = data.order.adresKontakt;
        other1Kontakt = data.order.other1Kontakt;
        other2Kontakt = data.order.other2Kontakt;

        return data;
    }
    let order = fetchOrder();

    const fetchChatMessagesCount = async () => {
        let buf = await network.getChatMessagesCount(id, +$user.id);
        return buf && buf[0] && buf[0].count ? +buf[0].count : 0;
    }
    let chat = fetchChatMessagesCount();

    // === Логика модального окна чата (логгера) ===
    let loggerModalOpen = false;
    let loggerModalUrl = '';

    function openLoggerModal(nomer) {
        loggerModalUrl = `https://logger.trademaster.pro/${nomer}?storage=comandir&user_id=${$user.id}&user_name=${$user.name}`;
        loggerModalOpen = true;
    }

    function closeLoggerModal() {
        loggerModalOpen = false;
        loggerModalUrl = '';
    }

    function handleKeydown(e) {
        if (e.key === 'Escape' && loggerModalOpen) closeLoggerModal();
    }


    let tv = '',
        delivery = '',
        idKontakt = '',
        nameKontakt = '',
        telefonKontakt = '',
        adresKontakt = '',
        other1Kontakt = '',
        other2Kontakt = ''
    ;

    const handlerChangeKontakt = async (e) => {
        let data = await order,
            value = e.target.value;

        if (data.kontakti.length && value) {
            let kontakt = data.kontakti.find((item) => item.nameKontakt === value);

            if (kontakt) {
                idKontakt = kontakt.idKontakt;
                telefonKontakt = kontakt.telefonKontakt;
                adresKontakt = kontakt.adresKontakt;
                other1Kontakt = kontakt.other1Kontakt;
                other2Kontakt = kontakt.other2Kontakt;
            }
        } else {
            idKontakt = '';
            telefonKontakt = '';
            adresKontakt = '';
            other1Kontakt = '';
            other2Kontakt = '';
        }
    }

    const handlerSaveContact = async () => {
        let data = await order;

        await network.saveKontakt({
            nom: id,
            vid: data.order.vid,
            idKontakt,
            nameKontakt,
            telefonKontakt,
            adresKontakt,
            other1Kontakt,
            other2Kontakt,
            actualnost: 1,
            user_kontr: +$user.idkontr,
        });

        let popup = new bootstrap.Modal(document.getElementById('modal-save'));
        popup.show();

        setTimeout(() => popup.hide(), 1500);
    }

    const handlerSaveDelivery = async () => {
        let data = await order;

        await network.saveDelivery({
            nom: id,
            vid: data.order.vid,
            tv: tv,
            dost: delivery,
        });

        let popup = new bootstrap.Modal(document.getElementById('modal-save'));
        popup.show();

        setTimeout(() => popup.hide(), 1500);
    }

    const handlerRemove = async () => {
        await network.saveKontakt({
            idKontakt,
            nameKontakt,
            telefonKontakt,
            adresKontakt,
            other1Kontakt,
            other2Kontakt,
            actualnost: 0,
            user_kontr: +$user.idkontr,
        });

        idKontakt = '';
        telefonKontakt = '';
        adresKontakt = '';
        other1Kontakt = '';
        other2Kontakt = '';
    }

    // === Смена статуса через viborkaTo ===
    const API_URL = 'https://api.trademaster.pro/proxy?apikey=7ofsUxeIiti8wQ8Rlvhteqm%2BjG1MkRD%2BdLlJfW9BxOWIyLUPIs8FueQ6IIa%2F';

    const statusesFor = (vid) => {
        const v = Number(vid);
        if (v === 16) {
            return [{ newVid: 21, label: 'В работу', icon: 'construct-outline', color: '#22c55e' }];
        }
        if (v === 21) {
            return [{ newVid: 22, label: 'Выполненные', icon: 'checkmark-done-outline', color: '#65a30d' }];
        }
        return [];
    };

    let statusLoading = null;
    let statusError = null;
    let statusSuccess = null;

    const handlerChangeStatus = async (newVid, statusLabel) => {
        statusLoading = newVid;
        statusError = null;
        statusSuccess = null;

        try {
            let data = await order;
            const nom = data.order.nomer;
            const vid = data.order.vid;
            const nomStr = data.order.nomerStr || String(nom);

            const query = `EXEC viborkaTo @nom = ${nom}, @vid = ${vid}, @newVid = ${newVid}`;

            const params = new URLSearchParams({ query, one: 'false' });
            const res = await fetch(`${API_URL}&${params.toString()}`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
            });

            if (!res.ok) throw new Error(`HTTP ${res.status}`);

            statusSuccess = statusLabel;
            // обновить данные заявки
            order = fetchOrder();

            network.sendChatMessage(nom, +$user.id, $user.name, 'Перевод в "' + statusLabel +'"', 'text');

            let popup = new bootstrap.Modal(document.getElementById('modal-status'));
            popup.show();
            setTimeout(() => popup.hide(), 1800);
        } catch (e) {
            console.error(e);
            statusError = 'Не удалось сменить статус. Попробуйте ещё раз.';
        } finally {
            statusLoading = null;
        }
    }
</script>

<svelte:window on:keydown={handleKeydown} />

<style>
    #contact .form-label {
        font-size: 12px;
        font-weight: normal;
    }
    #contact .btn.btn-icon.btn-outline-danger {
        border-top-left-radius: 0;
        border-bottom-left-radius: 0;
    }

    /* Сброс стилей кнопки вызова модалки в хедере */
    .header-chat-btn {
        background: transparent;
        border: none;
        padding: 0;
        display: flex;
        align-items: center;
        position: relative;
    }

    /* === Блок смены статуса === */
    .status-actions {
        margin: 12px 16px 8px;
        background: #f8f9fa;
        border: 1px solid #e4e6ea;
        border-radius: 10px;
        overflow: hidden;
    }
    .status-actions-title {
        font-size: 11px;
        font-weight: 600;
        color: #9ca3af;
        text-transform: uppercase;
        letter-spacing: 0.06em;
        padding: 10px 14px 6px;
    }
    .status-btn-list {
        list-style: none;
        margin: 0;
        padding: 0 0 6px;
    }
    .status-btn-item {
        padding: 2px 8px;
    }
    .status-btn {
        display: flex;
        align-items: center;
        gap: 10px;
        width: 100%;
        padding: 9px 12px;
        background: #fff;
        border: 1px solid #e9ecef;
        border-radius: 8px;
        font-size: 14px;
        font-weight: 500;
        color: #374151;
        cursor: pointer;
        transition: background 0.15s, transform 0.15s;
        text-align: left;
        border-left-width: 3px;
    }
    .status-btn:active:not(:disabled) {
        transform: scale(0.98);
    }
    .status-btn:disabled {
        opacity: 0.55;
        cursor: not-allowed;
    }
    .status-btn ion-icon {
        font-size: 18px;
        flex-shrink: 0;
    }
    .btn-spinner {
        width: 16px;
        height: 16px;
        border: 2px solid #d1d5db;
        border-top-color: #6b7280;
        border-radius: 50%;
        animation: spin 0.6s linear infinite;
        flex-shrink: 0;
    }
    .status-error {
        font-size: 12px;
        color: #dc2626;
        padding: 4px 14px 8px;
    }
    @keyframes spin { to { transform: rotate(360deg); } }

    /* === Модальное окно логгера (чата) === */
    .logger-modal-overlay {
        position: fixed;
        inset: 0;
        background: rgba(0, 0, 0, 0.5);
        z-index: 9999;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .logger-modal-window {
        position: relative;
        background: #fff;
        border-radius: 12px;
        overflow: hidden;
        box-shadow: 0 10px 40px rgba(0, 0, 0, 0.25);
        width: 90vw;
        max-width: 900px;
        height: 80vh;
    }

    .logger-modal-close {
        position: absolute;
        top: 8px;
        left: 8px;
        z-index: 10;
        width: 36px;
        height: 36px;
        border: none;
        border-radius: 50%;
        background: #fff;
        box-shadow: 0 1px 4px rgba(0, 0, 0, 0.2);
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 22px;
        cursor: pointer;
        -webkit-tap-highlight-color: transparent;
    }

    .logger-modal-iframe {
        width: 100%;
        height: 100%;
        border: none;
        display: block;
    }

    @media (max-width: 880px) {
        .logger-modal-overlay {
            padding: 0;
        }

        .logger-modal-window {
            width: 100vw;
            max-width: 100vw;
            height: 100vh;
            border-radius: 0;
        }

        .logger-modal-close {
            top: 12px;
            right: 12px;
        }
    }
</style>

<TopMenu title="Детали задачи #{id}">
    <Link to="/dashboard" class="headerButton goBack" slot="left">
        <ion-icon name="chevron-back-outline" role="img" class="md hydrated" aria-label="chevron back outline"></ion-icon>
    </Link>

    <button type="button" class="headerButton header-chat-btn" slot="right" on:click={() => openLoggerModal(id)}>
        <ion-icon name="mail-outline" role="img" class="md hydrated" aria-label="mail outline"></ion-icon>

        {#await chat}...{:then count}
            {#if count}
                <span class="badge badge-danger">{count}</span>
            {/if}
        {/await}
    </button>
</TopMenu>

<div class="extraHeader">
    <ul class="nav nav-tabs lined" role="tablist">
        <li class="nav-item">
            <a class="nav-link active" data-bs-toggle="tab" href="#info" role="tab" aria-selected="false">
                Информация
            </a>
        </li>
        <li class="nav-item">
            <a class="nav-link" data-bs-toggle="tab" href="#contact" role="tab" aria-selected="true">
                Контакт
            </a>
        </li>
    </ul>
</div>

<div id="appCapsule" class="extra-header-active">
    {#await order}
        <div class="section mt-2">
            <div class="card text-center">
                <div class="card-body p-5">
                    <h5 class="card-title">Загрузка</h5>
                    <p class="card-text">
                        Пожалуйста подождите, мы загружаем информацию по вашей заявке..
                    </p>
                </div>
            </div>
        </div>
    {:then data}
        <div class="tab-content mt-2">
            <!-- info tab -->
            <div class="tab-pane fade active show" id="info" role="tabpanel">
                <ul class="listview">
                    <li>
                        <div class="in">
                            <div>
                                <header>Задача</header>
                                <b>{data.order.name}</b>
                            </div>
                        </div>
                    </li>
                    <li>
                        <div class="in">
                            <div>
                                <header>Статус</header>
                                <b>
                                    {{
                                        16: 'Новый',
                                        17: 'Получение данных',
                                        18: 'Оценка',
                                        19: 'Согласование',
                                        20: 'Ожидание информации',
                                        21: 'В работе',
                                        22: 'Выполненные',
                                        23: 'Переданные',
                                        24: 'Завершенные'
                                    }[data?.order?.vid] ?? 'Неизвестный статус'}
                                </b>
                            </div>
                        </div>
                    </li>
                    <li>
                        <div class="in">
                            <div>
                                <header>Описание задачи</header>
                                <b>{data.order.komment}</b>
                            </div>
                        </div>
                    </li>
                    <li>
                        <div class="in">
                            <div>
                                <header>Исполнитель</header>
                                <b>{data.order.driver}</b>
                            </div>
                        </div>
                    </li>
                </ul>

                <!-- === Блок смены статуса === -->
                {#if statusesFor(data?.order?.vid).length}
                    <div class="status-actions">
                        <div class="status-actions-title">Перевести в статус</div>
                        <ul class="status-btn-list">
                            {#each statusesFor(data?.order?.vid) as s (s.newVid)}
                                <li class="status-btn-item">
                                    <button
                                            class="status-btn"
                                            style="border-left-color: {s.color};"
                                            on:click={() => handlerChangeStatus(s.newVid, s.label)}
                                            disabled={statusLoading !== null}
                                    >
                                        {#if statusLoading === s.newVid}
                                            <span class="btn-spinner"></span>
                                        {:else}
                                            <ion-icon name="{s.icon}" style="color: {s.color};"></ion-icon>
                                        {/if}
                                        {s.label}
                                    </button>
                                </li>
                            {/each}
                        </ul>
                        {#if statusError}
                            <div class="status-error">{statusError}</div>
                        {/if}
                    </div>
                {/if}
                <!-- === / Блок смены статуса === -->
            </div>
            <!-- * info tab -->

            <!-- contact tab -->
            <div class="tab-pane fade" id="contact" role="tabpanel">
                <ul class="listview mb-2">
                    <li>
                        <div class="in">
                            <div class="input-wrapper">
                                <div class="input-wrapper">
                                    <label class="form-label">Контакт</label>
                                    <div class="input-group">
                                        <input type="text" class="form-control" list="kontakt" on:input={handlerChangeKontakt} bind:value={nameKontakt}>
                                        {#if idKontakt}
                                            <div class="input-group-append">
                                                <button class="btn btn-icon btn-outline-danger" type="button" on:click={handlerRemove}>
                                                    <ion-icon name="trash-outline"></ion-icon>
                                                </button>
                                            </div>
                                        {/if}
                                    </div>
                                </div>
                                <datalist id="kontakt">
                                    {#each data.kontakti as item}
                                        <option value="{item.nameKontakt}">{item.adresKontakt} {item.telefonKontakt}</option>
                                    {/each}
                                </datalist>
                            </div>
                        </div>
                    </li>
                    <li>
                        <div class="in">
                            <div class="input-wrapper">
                                <label class="form-label">Телефон</label>
                                <input type="text" class="form-control" bind:value={telefonKontakt}>
                            </div>
                        </div>
                    </li>
                    <li>
                        <div class="in">
                            <div class="input-wrapper">
                                <label class="form-label">Электронная почта</label>
                                <input type="text" class="form-control" bind:value={other1Kontakt}>
                            </div>
                        </div>
                    </li>
                    <li>
                        <div class="in">
                            <div class="input-wrapper">
                                <label class="form-label">Адрес</label>
                                <textarea maxlength="1000" class="form-control" bind:value={adresKontakt}></textarea>
                            </div>
                        </div>
                    </li>
                    <li>
                        <div class="in">
                            <div class="input-wrapper">
                                <label class="form-label">Доп.инфо</label>
                                <textarea maxlength="1000" class="form-control" bind:value={other2Kontakt}></textarea>
                            </div>
                        </div>
                    </li>
                </ul>
                <div class="carousel-button-footer">
                    <div class="row">
                        <div class="col-12">
                            <button type="button" class="btn btn-primary btn-lg btn-block" on:click={handlerSaveContact}>Сохранить</button>
                        </div>
                    </div>
                </div>
            </div>
            <!-- * contact tab -->
        </div>

        <!-- Модалка: сохранено -->
        <div class="modal fade dialogbox" id="modal-save" data-bs-backdrop="static" tabindex="-1" style="display: none;" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-icon text-success">
                        <ion-icon name="checkmark-circle"></ion-icon>
                    </div>
                    <div class="modal-header">
                        <h5 class="modal-title">Сохранено</h5>
                    </div>
                    <div class="modal-footer">
                        <div class="btn-inline">
                            <a href="#" class="btn" data-bs-dismiss="modal">Закрыть</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Модалка: статус изменён -->
        <div class="modal fade dialogbox" id="modal-status" data-bs-backdrop="static" tabindex="-1" style="display: none;" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-icon text-success">
                        <ion-icon name="checkmark-circle"></ion-icon>
                    </div>
                    <div class="modal-header">
                        <h5 class="modal-title">Статус изменён</h5>
                        {#if statusSuccess}
                            <p class="modal-subtitle">{statusSuccess}</p>
                        {/if}
                    </div>
                    <div class="modal-footer">
                        <div class="btn-inline">
                            <a href="#" class="btn" data-bs-dismiss="modal">Закрыть</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    {/await}
</div>

<!-- Модальное окно чата (логгера) -->
{#if loggerModalOpen}
    <div class="logger-modal-overlay" on:click={closeLoggerModal}>
        <div class="logger-modal-window" on:click|stopPropagation>
            <button class="logger-modal-close" on:click={closeLoggerModal} aria-label="Закрыть">
                <ion-icon name="close-outline"></ion-icon>
            </button>
            <iframe
                    src={loggerModalUrl}
                    class="logger-modal-iframe"
                    title="Логгер задачи"
                    allow="clipboard-write"
            ></iframe>
        </div>
    </div>
{/if}
